<script>
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";
import Swal from "sweetalert2";


export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      }
    },
    data(){
        return{
            clientDevices: [],
            fields: [
                { key:"creationTimestamp", label: "Crée le"},
                { key:"code", label: "Identifiant du poste"},
                { key:"isAuthorized", label: "", thClass:"text-left", tdClass:"text-left"},
                { key:"customer", label: "Client"},
                { key:"creationUser", label: "Crée par"},
                { key:"creationIpAddress", label: "IP", sortable: false},
                { key:"userAgent", label: "Navigateur"},
                ],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            selectedCustomer:null,
            start:this.firstDay,
            end:this.lastDay,
            isGetStarting:false,

        }
    },
    methods:{
        getClientDevices(){
            this.isGetStarting=true
            ReportingApi.getClientDevices(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                (result) => {
                    if(result){
                        this.clientDevices=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetStarting=false
            })
        },
        getCustomers(){
            CustomersApi.getCustomers(null,null).then(
                response => {
                this.customersList=response;
                }
            )
        },

        ToggleAuth(device){
            
            Swal.fire({
                title: device.isAuthorized ? 'Bloquer' : 'Autoriser', 
                text: (device.isAuthorized ? 'Bloquer' : 'Autoriser') + ' le poste '+ device.code + ' de ' + device.customer,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: device.isAuthorized ?  "#f46a6a" : "#34c38f",
                cancelButtonColor: '#ddd',
                confirmButtonText: device.isAuthorized ? 'Bloquer' : 'Autoriser',
                cancelButtonText: 'Annuler',
            })
            
            .then(result => {
                if (result.value) {

                    ReportingApi.authorizeDevice(device.id, !device.isAuthorized).then(
                () => {
                    
                    this.getClientDevices();

                }
            ) 

                
                }
            });

        }
    },
    mounted(){
      this.getCustomers()
      this.getClientDevices()
    },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getClientDevices()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getClientDevices()
          }
        },

        selectedCustomer: function(){
            this.getClientDevices()
        }
    }
}
</script>
<template>
    <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-primary">Postes de travail</h4>
        <div  class="row mt-4">
            <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>
        <div class="table-responsive mb-0" style="max-height:31em;min-height:31em">
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="clientDevices"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>

            <template v-slot:cell(ip)="{value}">
                <code>{{value==null ? "_" : value}}</code>
            </template>

            <template v-slot:cell(userAgent)="{value}">
                <code>{{value==null ? "_" : value}}</code>
            </template>

             <template v-slot:cell(code)="{value, item}">
                <span :class="item.isAuthorized ? 'text-dark' : 'text-warning'">{{ value }}</span>
            </template>

            <template v-slot:cell(creationTimestamp)="{value, item}">
                <span :class="item.isAuthorized ? 'text-dark' : 'text-warning'">{{ value }}</span>
            </template>

            <template v-slot:cell(isAuthorized)="{value, item}">
                <b-button :title="value ? 'Bloquer' : 'Autoriser'"  size="sm"  :variant="value ? 'outline-warning' : 'outline-success'"  @click="ToggleAuth(item)"   >
                    <i :class="value ? 'fa fa-lock' : 'fa fa-unlock'" class="fas fa-info-circle  font-size-14  font-weight-bold align-middle"></i>
                    <!-- <span class=" font-weight-bold text-uppercase d-none d-sm-inline"> {{ value ? 'Bloquer' : 'Autoriser' }} </span>          -->
                </b-button>
            </template>





            </b-table>
            <span v-if="!isGetStarting && !clientDevices.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClientDevices()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getClientDevices()" :disabled="isGetStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 
    </div>
</template>